import styled from 'styled-components';

import { makeDefaultCellStyle } from './style';

import type { ThProps, ThComponent } from './types';

export const Th: ThComponent = styled.th<ThProps>((props) => {
  const {
    onClick,

    theme: { colors, fonts, table },
  } = props;

  const borderColor = colors[table.TH_BORDER_COLOR];

  const rowsBorder = `1px ${table.TH_BORDER_STYLE} ${borderColor}`;
  const sideBorder = table.TH_SIDE_BORDER_WIDTH > 0
    ? `${table.TH_SIDE_BORDER_WIDTH}px ${table.TH_BORDER_STYLE} ${borderColor}`
    : undefined;
  const solidBorder = `1px solid ${borderColor}`;
  const lastRowBorder = `2px solid ${borderColor}`;

  return {
    ...makeDefaultCellStyle(props),
    ...fonts[table.TH_FONT],
    color: colors[table.TH_COLOR],

    backgroundColor: table.TH_BACKGROUND_COLOR
      ? colors[table.TH_BACKGROUND_COLOR]
      : 'transparent',

    padding: table.TH_PADDING,
    borderTop: rowsBorder,
    borderLeft: sideBorder,
    borderRight: sideBorder,

    '&:hover': onClick
      ? {
        color: table.TH_COLOR_HOVER
          ? colors[table.TH_COLOR_HOVER]
          : undefined,

        backgroundColor: table.TH_BACKGROUND_COLOR_HOVER
          ? colors[table.TH_BACKGROUND_COLOR_HOVER]
          : undefined,

        cursor: 'pointer',
      }
      : undefined,

    '&:first-child': props.hasBorderLeft
      ? undefined
      : {
        borderLeft: 'none',
      },

    '&:last-child': props.hasBorderRight
      ? undefined
      : {
        borderRight: 'none',
      },

    'tr:first-child > &': {
      borderTop: solidBorder,
    },

    'tr:last-child > &': {
      borderBottom: lastRowBorder,
    },
  };
});
